import AddPageModal from "../../components/AddPage/AddPage";
import {useEffect, useState} from "react";
import http from "../../http";
import {message} from "antd";
import {useTranslation} from "react-i18next";


const CloudServiceAddPage=({visible, onClose, onSuccessSubmit, onErrorSubmit, edit, editItem, modalSize, reload})=>{
    const [initialValues, setInitialValues] = useState({});
    const { t } = useTranslation();
    const config = {
        addUrl: '/api/v1/auth/cloud_services/add/',
        editUrl: edit ? `/api/v1/auth/cloud_services/${editItem?.id}/edit/` : '',
        dataUrl: edit? `/api/v1/auth/cloud_services/${editItem?.id}/` : '',
        pageTitle: !edit ? t('cloud_service_addpage_title') : t('cloud_service_edit_button_text') + ' ' +`${editItem?.name || ''}`,
        colNo: 2,
        cancelButtonText: t('addpage_cancel_button_text'),
        saveButtonText: !edit ? t('addpage_save_button_text') : t('addpage_edit_button_text'),
        addSuccessMessage: !edit ? t('cloud_service_add_successful_message') : t('cloud_service_edit_successful_message'),
        modalSize: modalSize || 400,
        fields: [
            {
                name: 'name',
                label: t('cloud_services_name_field'),
                placeholder: t('cloud_services_name_field_placeholder'),
                isRequired: true,
                requiredMessage: t('cloud_services_name_field_required_text'),
                type: 'input',
                colNo: 1,
                order: 1
            },
            {
                name: 'admin_name',
                label: t('cloud_services_admin_name_field'),
                placeholder: t('cloud_services_admin_name_field_placeholder'),
                isRequired: false,
                requiredMessage: '',
                type: 'input',
                colNo: 1,
                order: 2
            },
            {
                name: 'email',
                label: t('cloud_services_email_field'),
                placeholder: t('cloud_services_email_field_placeholder'),
                isRequired: false,
                requiredMessage: '',
                type: 'input',
                colNo: 1,
                order: 3
            },
            {
                name: 'mobile',
                label: t('cloud_services_mobile_field'),
                placeholder: t('cloud_services_mobile_field_placeholder'),
                isRequired: false,
                requiredMessage: '',
                type: 'input',
                colNo: 1,
                order: 4
            },
            {
                name: 'service_category',
                label: t('cloud_services_category_field'),
                placeholder: t('cloud_services_category_field_placeholder'),
                isRequired: true,
                requiredMessage: t('cloud_services_category_field_required_text'),
                type: 'select',
                extraProps: {
                    url: '/api/v1/enums/CloudServiceCategoryChoices/combo/'
                },
                colNo: 2,
                order: 1,
            },
            {
                name: 'service_item',
                label: t('cloud_service_item_field'),
                placeholder: t('cloud_service_item_field_placeholder'),
                isRequired: true,
                requiredMessage: t('cloud_service_item_field_required_text'),
                type: 'select',
                extraProps: {
                    url: '/api/v1/enums/CloudServiceCategoryItemChoices/combo/'
                },
                colNo: 2,
                order: 2,
            }
        ]
    }

    useEffect(()=>{
        setInitialValues({});
        if(editItem){
            let dataUrl = `/api/v1/auth/cloud_services/${editItem?.id}/`;
            http.get(dataUrl).then((resp)=>{
                setInitialValues(resp.data);
            }).catch((err)=>{
                message.error('Loading Data Failed')
            })
        }
    }, [editItem])

    return <AddPageModal config={config} visible={visible} onClose={onClose} onSuccessSubmit={onSuccessSubmit} onErrorSubmit={onErrorSubmit} edit={edit} initialValues={initialValues}/>

}

export default CloudServiceAddPage;